(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["3-icon-text-ctm"] && !Shopify.designMode) return;
  try {
    
class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    
    if (this.sliderItems.length > 0) {
      this.currentElement = this.sliderItems[0];
      this.slider.addEventListener('scroll', this.update.bind(this));
      this.update();
    }
  }

  update() {
    const slideWidth = this.sliderItems[0].clientWidth;
    const scrollLeft = this.slider.scrollLeft;
    const currentIndex = Math.round(scrollLeft / slideWidth);
    
    this.currentElement = this.sliderItems[currentIndex];
    this.slider.scrollTo({
      left: currentIndex * slideWidth,
      behavior: 'smooth'
    });
  }
}

customElements.define('slider-component', SliderComponent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      
      // Add menu hover event listeners
      this.setupMenuHover();
    }

    setupMenuHover() {
      const menuItems = document.querySelectorAll('.header');
      const stickyHeader = this;

      menuItems.forEach(item => {
        item.addEventListener('mouseenter', () => {
          stickyHeader.classList.add('menu-hovered');
        });
        
        item.addEventListener('mouseleave', (e) => {
          // Check if any menu is open before removing the class
          const isAnyMenuOpen = document.querySelector('details[open]');
          if (!isAnyMenuOpen) {
            stickyHeader.classList.remove('menu-hovered');
          }
        });
      });

      // Add event listener for details tag to handle menu open/close
      document.addEventListener('click', (e) => {
        const details = e.target.closest('details');
        if (details) {
          if (!details.hasAttribute('open')) {
            stickyHeader.classList.remove('menu-hovered');
          }
        }
      });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["icon-text-blocks"] && !Shopify.designMode) return;
  try {
    
class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    
    if (this.sliderItems.length > 0) {
      this.currentElement = this.sliderItems[0];
      this.slider.addEventListener('scroll', this.update.bind(this));
      this.update();
    }
  }

  update() {
    const slideWidth = this.sliderItems[0].clientWidth;
    const scrollLeft = this.slider.scrollLeft;
    const currentIndex = Math.round(scrollLeft / slideWidth);
    
    this.currentElement = this.sliderItems[currentIndex];
    this.slider.scrollTo({
      left: currentIndex * slideWidth,
      behavior: 'smooth'
    });
  }
}

customElements.define('slider-component', SliderComponent);

  } catch(e) { console.error(e); }
})();
})();
